<template>
    <div class="container-fluid" v-if="school && department && program">
        <div class="row justify-content-between">
            <div class="col">
                <h3>Хичээлүүд /{{department.name}}{{program.name}})</h3>
                <h6>Xичээлийн тоо: {{classLessons.length}}</h6>
            </div>
        </div>
        <div class="container-fluid p-0">
                <div class="card shadow my-4">
                    <div class="card-header py-3">
                        <div class="row">
                            <div class="col">
                                <h6 class="m-0 font-weight-bold text-primary">Хичээлийн жагсаалт</h6>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive" v-if="classLessons!=null && classLessons.length>0">
                        <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                            <thead>
                            <tr>
                                <th>№</th>
                                <th>Нэр</th>
                                <th>Багш</th>
                                <th>Төрөл</th>
                                <th>Үйлдэл</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(lesson, index) in classLessons" v-bind:key="lesson.id">
                                    <td>{{index+1}}</td>
                                    <td>
                                        {{lesson.name}}  
                  
                                    </td>
                                    <td>
                                        <span v-if="lesson.teachers">
                                            {{lesson.teachers[0].firstName}}
                                        </span>
 
                                    </td>
                                    <td>
                                        <span class="badge badge-success mr-1" v-if="lesson.categoryTypeId=='zaaval'">Заавал судлаx</span>
                                        <span class="badge badge-warning mr-1" v-else>Сонгон судлаx</span>
                                        
                                        <span class="badge badge-danger" v-if="lesson.isGroup">Группээр</span>
                                        <span class="badge badge-primary" v-else>Ангиар</span>

                                    </td>
                                    <td>
                                        <button v-if="lesson.deleted!=undefined&&lesson.deleted==true" class="btn btn-sm btn-danger" @click="_addLesson(lesson)">Xасагдсан</button>
                                        <button v-else class="btn btn-sm btn-info" @click="_removeLesson(lesson)">Нэмэгдсэн байна</button>
                                    </td>
                                </tr>
                            
                            </tbody>
                        </table>
                            <div v-if="!searched">
                                <button v-if="loading==false" @click="getTeacherData()" class="nextbutton shadow" style=""><i class="fas fa-arrow-down fa-2x" style="color:black!important;height:40; width:40"></i></button>
                                <button v-else type="button" class="btn btn-success btn-block" disabled>
                                    <span class="spinner-border spinner-border-sm"></span>
                                    Loading..
                                </button>
                            </div>
                        </div>
                        <div v-else class="alert alert-info text-center">Одоогоор мэдээлэл ороогүй байна.</div>

                    </div>
                </div>
        </div>
    </div>
    
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
const fb = require('../../../firebaseConfig.js');
import timetable from '../shared/timetable.js';
import myfunction from '../../global/myfunction.js';
    export default {
        name:"CheckClassLessons",
        data() {
            return {
               tab_selected:0,
               classLessons:[],
               lastVisible:null,
               loading:false,
               last:false,
               showSimple:true,
               searchValue:null,
               searched:false,
               searchField:'email',
               pageSize:20,
               school:null,
               department:null,
               program:null,
               schedules:[],
               lines:[1, 2],
               times:[1, 2, 3, 4, 5, 6, 7],
               weekNumbers:[1,2,3,4,5],
               students:[],
            }
        },
        mixins:[timetable,myfunction],
        props: {
            schoolId: { 
                required: true,
            },
            departmentId:{
                required:true
            },
            programId:{
                required:true
            },
            
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {
            
            async _isLessonTobeRemoved(lesson){
                
                await fb.db.collection("schools/"+this.schoolId+"/removelesson-from-class").doc(lesson.id).get().then((log)=>{
                    if(log.exists) 
                        lesson.deleted = true
                    else lesson.deleted = false;
                }
                );
            },
            async _addLesson(lesson){
            
                await fb.db.collection("schools/"+this.schoolId+"/removelesson-from-class").doc(lesson.id).delete().then(function() {
                    lesson.deleted=false;
                }).catch(function(error) {
                    console.error("Error removing document: ", error);
                });

            },
            async _removeLesson(lesson){
                await fb.db.collection("schools/"+this.schoolId+"/removelesson-from-class").doc(lesson.id).set(
                {
                    createdAt: new Date(),
                    lessonId: lesson.id,
                    lesson: lesson,
                    //department: this.currentSelectedGroup.department,
                    departmentName: this.department.name,
                    //program: this.currentSelectedGroup.program,
                    programName: this.program.name
                },).then(()=>{
                    lesson.deleted=true;
                    // this.savingFinalGrades = false;
                    // this.currentSelectedGroup.finalGradeConfirmed = true;
                });
            },
            async _findCategory(schoolId,lesson){
                var catRef = fb.db.collection("schools/"+schoolId+"/categories").doc(lesson.category.id);
                await catRef.get().then(function(doc) {
                    lesson.categoryTypeId = doc.data().typeDetail.id;
                    lesson.categoryTypeName = doc.data().typeDetail.name;
                }).catch(function(error) {
                    console.log("Error getting cached document:", error);
                });
            },
            _getScore(lesson,student){
                for(var c of student.finalScores){
                    if(lesson.id==c[0]) {
                        if(c[1]>91) return "<span class='bg-success px-2' style='color:white'>"+c[1]+"</span>";
                        else if([1]>81) return "<span class='bg-info px-2'>"+c[1]+"</span>";
                        else if(c[1]>71) return "<span class='px-2' style='background:#a0b8ff; color:black'>"+c[1]+"</span>";
                        else if(c[1]>61) return "<span class='px-2' style='background: #ffffd3; color:black'>"+c[1]+"</span>";
                        else return "<span class='px-2' style='background:#ffb5ae; color:black;'>"+c[1]+"</span>";
                    }
                }
                // return "<span style='background-color:black=; color:white'>"+(-1)+"</span>";;
                return '';
            },
            _getShortName(name){
                return name.substring(0,4);
            },
            _selectTab(index){
                this.tab_selected = index;
                console.log(index);
            },
            async _getData(){
                var schoolDoc=await fb.db.doc('schools/'+this.schoolId).get();
                if(schoolDoc.exists){
                    let school=schoolDoc.data();
                    school.id=schoolDoc.id;
                    school.ref=schoolDoc.ref;
                    this.school=school
                    this.teacheclassLessonsrs=[];

                    var departmentDoc=await schoolDoc.ref.collection("departments").doc(this.departmentId).get();
                    if(departmentDoc.exists){
                        let department=departmentDoc.data();
                        department.id=departmentDoc.id;
                        department.ref=departmentDoc.ref;
                        this.department=department

                        var programDoc=await departmentDoc.ref.collection("programs").doc(this.programId).get();
                        if(programDoc.exists){
                            let program=programDoc.data();
                            program.id=programDoc.id;
                            program.ref=programDoc.ref;
                            this.program=program;
                        }
                    }
                    await this.getTeacherData();
                }
            },
            contains(list, item){
                var result=false;
                if(list && list.length>0){
                    for(const object of list){
                        if(object && item && object.id==item.id){
                            resutl=true;
                            break;
                        }
                    }
                }
                return result;

            },
            async _findCategory(schoolId,lesson){
                var catRef = fb.db.collection("schools/"+schoolId+"/categories").doc(lesson.category.id);
                await catRef.get().then(function(doc) {
                    lesson.categoryTypeId = doc.data().typeDetail.id;
                    lesson.categoryTypeName = doc.data().typeDetail.name;
                }).catch(function(error) {
                    console.log("Error getting cached document:", error);
                });
            },
            async getTeacherData(){

                var query=fb.db.collection("schools/"+this.schoolId+"/lessons")
                    .where("programs", "array-contains", 
                        fb.db.doc("/schools/"+this.schoolId+"/departments/"+this.departmentId+"/programs/"+this.programId)
                    );
                
                if(query!=null){
                    var lessonsDatas=await query.get();
                    this.lastVisible= lessonsDatas.docs[lessonsDatas.docs.length-1];

                    for(const doc of lessonsDatas.docs){

                        let lesson=doc.data()
                        lesson.id = doc.id;
                        lesson.procent=0;
                        lesson.ref = doc.ref;

                        if(lesson.category && lesson.category.id){
                            await this._findCategory(this.schoolId,lesson);
                        }
                        
                        if(lesson && lesson.numberOfUnderstand && lesson.numberOfTotalStatus){
                            lesson.procent=(lesson.numberOfUnderstand*100/lesson.numberOfTotalStatus).toFixed(2)
                        }

                  
                        await this._isLessonTobeRemoved(lesson);
                        this.classLessons.push(lesson);
                    };
                
                }
            },

            search(value){
                if(value!=null && value!='' && this.searchField!=null && this.searchField!=''){
                    this.lastVisible=null;
                    this.last=false;
                    this.searched=true;
                    this.classLessons=[];
                    this.searchBy(value);
                }
                
            },
            async searchBy(value){
                if(this.searchField=="code")
                    value=value.toLowerCase();
                    this.loading=true;
                    var query;
                    query=fb.db.collection("schools/"+this.schoolId+"/categories").where(this.searchField, "==", value);
                    // if(this.schools!=null){
                    //     query=query.where('school', "in", this.schools)
                    // }

                    if(query!=null){
                        var documentSnapshots=await query.get();
                        documentSnapshots.forEach(doc=> {
                            let object=doc.data();
                            object.id = doc.id;
                            this.classLessons.push(object);
                        });

                    }
                    this.loading=false;

            },
            goLessonDetail(lesson){
                if(this.userProfile && this.userProfile.role=="teacher")
                    this.$router.push({ name: 'LessonDetailPublic', params: { lessonId: lesson.id, schoolId: this.schoolId, sts: true} });
                else
                    this.$router.push({ name:'SLessonDetail', params:{ schoolId: schoolId, lessonId: teacher.id } });
            },
            _getTimeObject(day,line,time){
                var results=[];
                if(day && line && time){
                    if(this.schedules && this.schedules.length>0){
                        for(const schedule of this.schedules){
                            if(schedule && schedule.day==day && schedule.line==line && schedule.time==time){
                                results.push(schedule);
                            }
                        }
                    }
                }
                return results;
            },
            splitName(name){
            if(name && name.includes("/")){
                var n = name.indexOf("/");
                return name.substring(n, name.length);
            }
            return name;
            },

  
        },
        created() {

            this.classLessons=[];
            this._getData();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).fromNow()
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
